// iter84.69 — extracted from pages/TournamentSetup.jsx (tech-debt sweep).
// Static template-picker config: sport groups, presets, formats, data feeds.

// iter63p — Two-level sport→template picker. Top-level sport groups
// (soccer/football/basketball/olympics/custom); selecting a sport reveals
// its templates underneath. Sports without enabled templates render as
// "Coming soon" tiles that can't be opened.
export const SPORTS = [
    { key: "soccer",     label: "Soccer",     icon: "⚽", available: true,  desc: "World Cup, Champions League, Women's WC." },
    { key: "golf",       label: "Golf",       icon: "⛳", available: true,  desc: "Majors pick'em & position drafts." },
    { key: "football",   label: "Football",   icon: "🏈", available: true,  desc: "NFL season pick'em — playoffs & CFP coming." },
    { key: "baseball",   label: "Baseball",   icon: "⚾", available: true,  desc: "MLB Playoffs — pick pot, Champions Pick, Series Predictor." },
    { key: "basketball", label: "Basketball", icon: "🏀", available: true,  desc: "NBA Playoffs — pick pot, Champions Pick, Series Predictor." },
    // iter87.553 — Squares promoted to its own top-level sport (was
    // nested under Football → Style). Whole tile greys out in one shot
    // for free-tier accounts via `proPlusOnly` — see TemplatePicker's
    // sport-tile `renderTile`.
    { key: "squares",    label: "Squares",    icon: "🔲", available: true,  desc: "10x10 digits board on one marquee NFL/CFB game.", proPlusOnly: true },
    { key: "olympics",   label: "Olympics",   icon: "🏅", available: false, desc: "Group + medal-round formats.", badge: "Coming soon" },
    { key: "custom",     label: "Custom",     icon: "🛠️", available: true,  desc: "Build any bracket from scratch." },
];

export const TEMPLATE_PRESETS = [
    // iter63k — API-Football-native WC templates are the primary options
    // for new tournaments. Legacy `world_cup` / `world_cup_knockout` stay
    // in the codebase for existing tournaments but are hidden here.
    { key: "world_cup_api",     sport: "soccer",     label: "World Cup",                 icon: "⚽", desc: "48 teams, 12 groups + knockout. Powered by API-Football — auto-imports fixtures, scores, and bracket.", available: true },
    { key: "world_cup_ko_api",  sport: "soccer",     label: "World Cup — Knockout",      icon: "⚽", desc: "32-team knockout-only bracket. API-Football populates fixtures + scores as the bracket resolves.", available: true },
    // iter86.13 — ONE Club Season card with a league dropdown (user-requested
    // over three separate cards). `leagues` drives the in-card selector; the
    // submitted template is the chosen league key. Per-league visibility
    // overrides still apply to the dropdown options.
    {
        key: "club_season", sport: "soccer", label: "Club Season", icon: "🏟️",
        desc: "Draft clubs, score every league match all season. W/D/L points — pick your league below.",
        available: true,
        leagues: [
            { key: "premier_league_api", label: "Premier League", icon: "🦁" },
            { key: "la_liga_api",        label: "La Liga",        icon: "🇪🇸" },
        ],
    },
    // iter86.41 — Season Pot Pick'em: the golf lowest-avg pot method for
    // club seasons. Same league feeds; NO draft — tiered pot picks.
    {
        key: "club_pot_pickem", sport: "soccer", label: "Club Season — Pot Pick'em", icon: "🎯",
        desc: "No draft — everyone picks clubs from tiered pots (overlap allowed). W/D/L points all season; Power Pick multiplies by pot (1x/1.5x/2x).",
        available: true,
        leagues: [
            { key: "pickem:premier_league_api", label: "Premier League", icon: "🦁" },
            { key: "pickem:la_liga_api",        label: "La Liga",        icon: "🇪🇸" },
            // iter87.199.160 — Serie A retired (zero adoption), replaced
            // by UEFA Champions League (pot pick'em only — no draft mode).
            { key: "pickem:champions_league_api", label: "Champions League", icon: "🏆" },
        ],
    },
    { key: "champions_league",  sport: "soccer",     label: "European Champions League", icon: "🏆", desc: "32-team group stage + knockout. Across UEFA member clubs.", available: false, badge: "Coming soon" },
    { key: "golf_pickem_lowest_avg_api", sport: "golf", label: "Lowest Average Score", icon: "⛳", desc: "The Open Championship. Pick 6 golfers from tiered OWGR pots (overlap allowed) — lowest average strokes per round played wins. Power Pick shaves 2 strokes per round.", available: true },
    { key: "golf_position_draft_api",    sport: "golf", label: "Position Draft",       icon: "🏌️", desc: "The Open Championship. Auto-snake draft of the OWGR top 30 — earn points for made cuts and final positions 1–10.", available: true },
    { key: "womens_world_cup",  sport: "soccer",     label: "Women's World Cup",         icon: "⚽", desc: "FIFA Women's World Cup — groups + knockout.", available: false, badge: "Coming soon" },
    { key: "nfl_playoffs",      sport: "football",   label: "NFL Playoffs",              icon: "🏈", desc: "14-team single-elimination playoff bracket.", available: false, badge: "Coming soon" },
    { key: "fbs_playoffs",      sport: "football",   label: "FBS Playoffs",              icon: "🏈", desc: "College Football Playoff bracket.", available: false, badge: "Coming soon" },
    { key: "nba_playoffs",      sport: "basketball", label: "NBA Playoffs",              icon: "🏀", desc: "16-team conference playoff bracket.", available: false, badge: "Coming soon" },
    { key: "march_madness",     sport: "basketball", label: "March Madness",             icon: "🏀", desc: "64-team single-elimination. 4 regions, 16 seeds.", available: false, badge: "Coming soon" },
    { key: "olympics",          sport: "olympics",   label: "Olympics",                  icon: "🏅", desc: "Group + medal rounds.", available: false, badge: "Coming soon" },
    { key: "mlb_playoffs_api",  sport: "baseball",   label: "MLB Playoffs",              icon: "⚾", desc: "6-team pick pot (no draft) + Champions Pick (AL/NL/WS) + Series Predictor. Auto-synced from Highlightly.", available: true },
    { key: "custom",            sport: "custom",     label: "Custom",                    icon: "🛠️", desc: "Build any format: groups + knockout, knockout-only, or round-robin.", available: true },
];

export const FORMAT_OPTIONS = [
    { key: "group_knockout", label: "Group stage + Knockout", desc: "Teams split into groups (A, B, C…), play round-robin within group, top finishers advance to knockout bracket." },
    { key: "knockout_only", label: "Single-elimination bracket", desc: "Straight bracket. Pick a bracket size; teams seeded 1 vs N, 2 vs N-1, etc." },
    { key: "round_robin", label: "Round-robin (regular season)", desc: "Every team plays every other team once. Whoever finishes with most points wins." },
];

export const KNOCKOUT_SIZES = [4, 8, 16, 32, 64];

// iter86.45 — Consolidated picker config (user-requested redesign).
// Soccer "Tournament" card: dropdown 1 = tournament, dropdown 2 = type.
// Only types that map to a REAL enabled template appear; coming-soon
// tournaments render as disabled options.
export const SOCCER_TOURNAMENTS = [
    {
        key: "world_cup", label: "World Cup", icon: "⚽",
        types: [
            { key: "world_cup_api",    label: "Groups + Knockout", desc: "48 teams, 12 groups + knockout. Powered by API-Football — auto-imports fixtures, scores, and bracket." },
            { key: "world_cup_ko_api", label: "Knockout only",     desc: "32-team knockout-only bracket. API-Football populates fixtures + scores as the bracket resolves." },
        ],
    },
    { key: "champions_league", label: "Champions League", icon: "🏆", comingSoon: true, types: [] },
    { key: "womens_world_cup", label: "Women's World Cup", icon: "⚽", comingSoon: true, types: [] },
];

// Club Season card: dropdown 1 = team selection mode.
export const CLUB_MODES = [
    { key: "draft", label: "Auto Draft", desc: "Snake-draft clubs with your crew — every club belongs to ONE crewmate. Score every league match all season: W/D/L points." },
    { key: "pot",   label: "Pot Pick'em", desc: "No draft — everyone picks clubs from tiered pots (overlap allowed). W/D/L points all season; Power Pick multiplies by pot (1×/1.5×/2×)." },
];

// Dropdown 2 = league. `rounds` drives the season-window matchweek labels
// (dynamic leagues default to 38 unless their binding says otherwise).
// iter87.233 (operator cleanup) — Premier League / La Liga REMOVED
// from here. They no longer offer a "full season" option at all — see
// CLUB_LEAGUES_HALVES below.
export const CLUB_LEAGUES = [
    // iter87.199.160 — UCL league phase is 8 matchdays (Swiss-style,
    // not a 38-round full round-robin) — Pot Pick'em only (see
    // `_clubModesFor` — draft mode is hidden site-wide since Super
    // Draft's retirement anyway, so this is moot in practice). Stays
    // full-season-only: no "half" concept for an 8-game phase.
    // iter87.459 (user-requested) — no icon: cartoon-style league
    // emojis removed site-wide from Club Season / Weekly Pick'em.
    { key: "champions_league_api", label: "Champions League", rounds: 8 },
];

// iter87.233 — Premier League / La Liga club season is 1st-Half /
// 2nd-Half ONLY now (operator cleanup: "the season's already kicked
// off, so a 'full season' pick doesn't make sense anymore, and I don't
// want a dropdown — I want to just pick"). Both tiles per league commit
// the SAME underlying template as before — `season_window` is the only
// thing that differs (plus 2nd-Half's live-standings pots, see
// `_seed_pots_from_standings` in template_bindings.py). UCL is
// deliberately NOT here — its 8-game league phase has no "half".
export const CLUB_LEAGUES_HALVES = [
    // iter87.459 (user-requested) — no icon: cartoon-style league
    // emojis removed site-wide from Club Season / Weekly Pick'em
    // (flags are fine on their own, but for consistency every league
    // pill in these two sections now shows plain text, no icon at all).
    { key: "premier_league_api__1h", template: "premier_league_api", window: "first_half",  label: "Premier League — 1st Half", rounds: 38 },
    { key: "premier_league_api__2h", template: "premier_league_api", window: "second_half", label: "Premier League — 2nd Half", rounds: 38 },
    { key: "la_liga_api__1h",        template: "la_liga_api",        window: "first_half",  label: "La Liga — 1st Half",        rounds: 38 },
    { key: "la_liga_api__2h",        template: "la_liga_api",        window: "second_half", label: "La Liga — 2nd Half",        rounds: 38 },
];

// Golf card: dropdown 1 = event (curated bindings), dropdown 2 = type.
// `team_golf` is a placeholder for the Ryder/Presidents/Solheim format.
export const GOLF_TYPES = [
    { key: "golf_pickem_lowest_avg_api", label: "Lowest Average Score", desc: "Pick 6 golfers from tiered OWGR pots (overlap allowed) — lowest average strokes per round played wins. Power Pick shaves 2 strokes per round." },
    { key: "golf_position_draft_api",    label: "Position Draft",       desc: "Auto-snake draft of the OWGR top 30 — earn points for made cuts and final positions 1–10." },
    { key: "team_golf",                  label: "Team Golf — Ryder Cup style", desc: "Team-vs-team golf (Ryder / Presidents / Solheim Cup) scored on golfer points.", comingSoon: true },
];

// iter87.199.162 — Soccer Weekly Spread card (EPL + La Liga). Same
// shape as NFL/CFB Weekly Pick'em — boost IS the whole game, full
// season only (no first/second-half window — that's a Club Season
// pot-pickem-only option). Reuses the NFL wizard's picks-per-round
// state/payload field (`nfl_picks_per_round`) rather than adding a
// new one — it's a generic "picks per week" knob, not NFL-specific.
export const SOCCER_BOOST_TYPES = [
    // iter87.459 (user-requested) — no icon, see CLUB_LEAGUES_HALVES above.
    { key: "epl_boost_api", label: "Premier League" },
    { key: "la_liga_boost_api", label: "La Liga" },
];

// iter86.63 → iter87.111 — Football card: NFL Season Pot Pick'em +
// NFL Weekly Spread Boost (both use the API-Sports American Football
// feed). Playoff bracket templates are on the roadmap but not exposed
// in the wizard until the KO engine is wired.
export const NFL_TYPES = [
    {
        key: "pickem:nfl_season_api",
        visKey: "nfl_season_api",
        label: "NFL Season — Pot Pick'em",
        desc: "Pick 8 teams from 4 pots tiered by preseason Super Bowl odds (2 per pot, overlap allowed). Score 3 per win + 1 per tie all season — records sync straight from the NFL feed. Champions Pick: call the best regular-season record for +15 (ties all pay).",
    },
    {
        key: "nfl_boost_api",
        visKey: "nfl_boost_api",
        label: "Weekly Pick'em",
        desc: "Every week, the crew picks its chosen number of spread bets (default 8, admin-adjustable) from the full NFL slate. No draft, no team assignments — just pure spread hunting. Scored on the 6/2/0/-2 ladder: win + cover +6 · win but no cover +2 · loss that covers 0 · miss both −2. Ties count as losses (very American 🇺🇸). Regular season only (Weeks 1-18); playoffs will be a separate template later.",
    },
];

// iter87.230 → iter87.374 — Football → Playoffs style. Two live
// leagues (NFL/CFB), both API-Sports-backed knockout brackets. CFB
// still runs Team Pick Pot + Playoff Predictor between rounds. NFL
// retired its draft in iter87.374 (user-requested) in favor of a pure
// pick'em: Super Bowl Champion + Dark Horse Picks, same shape as NWSL
// Playoffs. No picks-per-round knob here — Playoff Predictor is fixed
// at 2/round (1 for the Super Bowl / National Championship).
export const FOOTBALL_PLAYOFFS_TYPES = [
    {
        key: "nfl_playoffs_api",
        visKey: "nfl_playoffs_api",
        label: "NFL Playoffs",
        desc: "14-team bracket (7 AFC + 7 NFC, 1 bye each). Pure pick'em — Super Bowl Champion (1-2 picks, half-points if hedging) + Dark Horse Picks (1 wild-card seed 5-7 per conference, +pts/win). Playoff Predictor: 2 picks/round, 1 for the Super Bowl.",
    },
    {
        key: "cfb_playoffs_api",
        visKey: "cfb_playoffs_api",
        label: "CFB Playoffs",
        desc: "12-team bracket, top 4 seeds get a first-round bye. Pick 1 from Pot 1, 2 from Pot 2, 2 from Pot 3 — round wins score 6 \u2192 8 \u2192 10 \u2192 12. Playoff Predictor: 2 picks/round, 1 for the National Championship.",
    },
];

// iter87.548 → iter87.553 — Squares. Pro+/comp-only single-game Squares
// boards (replaces the never-built "bowl pickem" idea with a proper
// 10x10 digits board). Squares is its own top-level sport now (Sport →
// Mode → League), so each entry carries `mode` (pickem/auto) + `league`
// (nfl/cfb) for Step 2/3 filtering — the template `key` itself is still
// the single source of truth for what gets created. Admin attaches the
// exact real game after creation via the Squares tab, picked from a
// CURATED shortlist (Super Bowl/Conference Championships for NFL; CFP
// bowl-site games + National Championship for CFB) — no free-text
// search.
export const SQUARES_MODES = [
    { key: "pickem", label: "Pick'em Squares", desc: "Players claim their own boxes by hand (admin-set cap per player, default 20) — row/column digits stay hidden until lock." },
    { key: "auto",   label: "Auto-Draw",       desc: "Boxes are randomly dealt to confirmed players at lock instead of picked by hand." },
];

export const FOOTBALL_SQUARES_TYPES = [
    {
        key: "nfl_squares_manual_api",
        visKey: "nfl_squares_manual_api",
        mode: "pickem",
        league: "nfl",
        label: "NFL",
        desc: "10x10 digits board on one real NFL game — Super Bowl or a Conference Championship, picked from a curated list after creation. Players claim their own boxes (admin-set cap per player, default 20) — row/column digits stay hidden until lock. Pro+/comp only.",
        proPlusOnly: true,
    },
    {
        key: "nfl_squares_auto_api",
        visKey: "nfl_squares_auto_api",
        mode: "auto",
        league: "nfl",
        label: "NFL",
        desc: "Same 10x10 board on a curated NFL game, but boxes are randomly dealt to confirmed players at lock instead of picked by hand. Pro+/comp only.",
        proPlusOnly: true,
    },
    {
        key: "cfb_squares_manual_api",
        visKey: "cfb_squares_manual_api",
        mode: "pickem",
        league: "cfb",
        label: "CFB",
        desc: "10x10 digits board on one real CFB playoff game — a CFP quarterfinal/semifinal bowl or the National Championship, picked from a curated list after creation. Players claim their own boxes (admin-set cap per player, default 20) — digits stay hidden until lock. Pro+/comp only.",
        proPlusOnly: true,
    },
    {
        key: "cfb_squares_auto_api",
        visKey: "cfb_squares_auto_api",
        mode: "auto",
        league: "cfb",
        label: "CFB",
        desc: "Same 10x10 board on a curated CFB playoff game, but boxes are randomly dealt to confirmed players at lock instead of picked by hand. Pro+/comp only.",
        proPlusOnly: true,
    },
];

// iter83.5 — Data-source picker for CUSTOM tournaments. Templates always
// use the platform's contracted feeds (no override). Each option here
// corresponds to a sync tab that gets surfaced in the AdminPanel for the
// tournament once it's created.
// iter84.4 — CSV is no longer hard-disabled; visibility is gated by the
// per-league site-admin `feed_csv_enabled` flag instead.
export const DATA_SOURCE_OPTIONS = [
    {
        key: "manual",
        icon: "📋",
        label: "Manual entry",
        desc: "You'll enter every match result by hand. No external sync, no Data Feed card. Best for small or ad-hoc tournaments.",
    },
    {
        key: "gotsport",
        icon: "🏆",
        label: "GotSport sync",
        desc: "Pull schedule + scores from a GotSport public event. You'll configure the event/group inside admin after creation.",
    },
    {
        key: "csv",
        icon: "📊",
        label: "CSV upload",
        desc: "Upload a CSV per week or round. The admin Data Feed tab will guide you through the file format.",
    },
];

// iter84.4 (Phase 2) — Terms of Use text shown in the modal before a
// league admin can choose a non-manual data feed. Each feed has its own
// short, clear blurb so admins know exactly what they're agreeing to.
export const DATA_SOURCE_TERMS = {
    gotsport: {
        title: "GotSport public-schedule terms",
        body: [
            "You confirm you have permission to use the GotSport event/group data you are about to import (e.g. you are an organiser, coach, or registered manager for the tournament).",
            "Schedule and score data is fetched from GotSport's public endpoints. Tiny Crew Rivalries does not warrant uptime, accuracy, or completeness of upstream data.",
            "Re-distribution or commercial use of GotSport data beyond your own crew's pick'em pool is not permitted.",
        ],
    },
    csv: {
        title: "CSV upload terms",
        body: [
            "You confirm that the match data in your CSV file is yours to upload — either it's a tournament you organise, a public dataset, or something you have explicit permission to use.",
            "You understand that uploaded data will be visible to every participant in this rivalry and will be used to drive leaderboard scoring.",
            "Tiny Crew Rivalries will run aggregate validation on your file. If the structure is invalid, the upload will be rejected with a full error report (no partial inserts).",
        ],
    },
};

